var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNgc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#f80000",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16.842L13.804 26l.247-7.441H12.5l.634-6.532 7.084-.976-2.326 5.925zm-5.498 6.498v-1.75c0-.13-.11-.236-.246-.236s-.247.105-.247.235v1.751c0 .13.11.236.247.236s.246-.106.246-.236zm-1.832-5.286h1.41l-.065 2.693c-.001.071.027.14.079.19s.123.08.197.08h.012a.27.27 0 00.275-.258l.065-3.177h-1.41l.473-5.219c.005-.06-.016-.12-.059-.165s-.103-.07-.167-.07h-.04a.223.223 0 00-.226.197zm0-6.6L15.778 9.3c.14-2.155-1.27-2.492-1.27-2.492L14.72 6c2.326.673 1.974 3.232 1.974 3.232l3.383 1.414z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgc);
export default __webpack_public_path__ + "static/media/ngc.da9616115752d01a11401654673aad20.svg";
export { ForwardRef as ReactComponent };